{
  "version": 1,
  "asset_id": "1f49618a-f90a-46cc-8d92-5e6066a92bb7",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/1f49618a-f90a-46cc-8d92-5e6066a92bb7/anglo.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/1f49618a-f90a-46cc-8d92-5e6066a92bb7/anglo.png",
  "original_filename": "anglo.png",
  "size": 14400,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:00Z"
}
